/**
 * Created by uri.khaimov on 05/03/2017.
 */
import {axiosInstance} from '../utils/helpers';
import C_HEADER from  '../constants/header';
import {setFetchingCount} from './app';

export function getUserLogo() {
    return (dispatch) => {
        dispatch(setFetchingCount(true));
        axiosInstance.get('api/v1/account/logo')
            .then((response) => {
                let logoUrl = response.data.logo_url;
                dispatch({
                    type: C_HEADER.SET_USER_LOGO,
                    payload: logoUrl
                });

            }, () => {
                let logoUrl = '';
                dispatch({
                    type: C_HEADER.SET_USER_LOGO,
                    payload: logoUrl
                })
            })
            .finally(() => {
                dispatch(setFetchingCount(false));
            });
    }
}


// WEBPACK FOOTER //
// ./actions/header.js